<soft-page>
  <router-outlet />
</soft-page>

<ng-template #menuBarTemplate>
  <div class="flex w-full min-w-0" data-testid="kundenabfrage-customer-search">
    <soft-field-ok
      class="flex-1 min-w-0 max-w-xl"
      fieldOkName="ktostamm.kunde"
      [placeholder]="'#CUSTOMER.SEARCH_PLACEHOLDER' | translate"
      (valueChange)="selectCustomer($event)"
    />
  </div>
</ng-template>
